import React, { useState, useContext } from "react";
import './collapsible-menu.css';
import { DoubleRightOutlined, DoubleLeftOutlined } from '@ant-design/icons';
import { Button, Menu } from 'antd';
import { ItemsContext } from "../itemContext/itemContext";

function CollapsibleMenu() {

    const {items, selectedItem, onClickTitle } = useContext(ItemsContext);
    const [collapsed, setCollapsed] = useState(false);

    const toggleCollapsed = () => {
        setCollapsed(!collapsed);
    };

    return (
        <span className='menu-wrapper'>
            <Button onClick={toggleCollapsed} className='collapse-icon' type='text' style={{ color: 'white' }}>
                {collapsed ? <DoubleRightOutlined /> : <DoubleLeftOutlined />}
            </Button>
            <Menu
                onClick={onClickTitle}
                className='menu'
                selectedKeys={selectedItem}
                mode="inline"
                items={items}
                inlineCollapsed={collapsed}
                theme='dark'
            />
        </span>
    )
}

export default React.memo(CollapsibleMenu);